import {columnObjectAlignCenter, columnObjectAlignLeft} from '@utils/tableHelpers';

export const columns = {
    'content': {
        label: 'Content',
        sorting: (row) => (row.event_content.view_name),
        ...columnObjectAlignLeft,
    },
    'cidrs': {
        label: 'CIDR ranges',
        sorting: (row) => row.cidrs || '',
        ...columnObjectAlignLeft,
    },
    'clients': {
        label: 'Clients',
        ...columnObjectAlignLeft,
    },
    'description': {
        label: 'Description',
        ...columnObjectAlignLeft,
    },
    'actions': {
        label: 'Actions',
        ...columnObjectAlignCenter,
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
};
